define.alias("shared/components/shared/addon-details-card", "media/components/shared/addon-details-card");